import { Eye, GraduationCap, CheckCircle, Activity } from "lucide-react";

export default function Products() {
  return (
          <section id="products" className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-black mb-4">Complete Product Suite</h2>
            <p className="text-xl text-gray-600">Four powerful products, one integrated platform</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* SalesBee */}
            <div className="bg-white group rounded-2xl p-8 shadow-lg border-2  border-gray-300 hover:border-[#FFC33A] relative">
         
              <Eye className="w-12 h-12 text-gray-400 group-hover:text-[#FFC33A] mb-4" />
              <h3 className="text-2xl font-bold text-black mb-3">SalesBee</h3>
              <p className="text-gray-600 mb-4">3D/AR/VR sales enablement platform for immersive product demonstrations</p>
              <ul className="space-y-2 text-sm text-gray-700 mb-6">
                <li>• Interactive 3D demos</li>
                <li>• AR/VR visualization</li>
                <li>• Offline capability</li>
                <li>• Analytics dashboard</li>
              </ul>
              <a href="#signup" className="block w-full bg-gray-200 group-hover:bg-[#FFD766] text-black text-center py-3 rounded-lg transition font-semibold">
              Know More
              </a>
            </div>

            {/* SkillBee */}
            <div className="bg-white group rounded-2xl p-8 shadow-lg border-2 border-gray-300 hover:border-[#FFC33A]  transition">
             
              <GraduationCap className="w-12 h-12 text-gray-400 group-hover:text-[#FFC33A] mb-4" />
              <h3 className="text-2xl font-bold text-black mb-3">SkillBee</h3>
              <p className="text-gray-600 mb-4">3D training manuals, SOPs, and LMS for XR education</p>
              <ul className="space-y-2 text-sm text-gray-700 mb-6">
                <li>• Interactive 3D SOPs</li>
                <li>• Training content hosting</li>
                <li>• LMS capabilities</li>
                <li>• Progress tracking</li>
              </ul>
              <a href="#signup" className="block w-full bg-gray-200 group-hover:bg-[#FFC33A] text-black text-center py-3 rounded-lg transition font-semibold">
              Know More
              </a>
            </div>

            {/* CheckBee */}
            <div className="bg-white group rounded-2xl p-8 shadow-lg border-2 border-gray-300 hover:border-[#FFC33A] transition">
              
              <CheckCircle className="w-12 h-12 text-gray-400 group-hover:text-[#FFC33A] mb-4" />
              <h3 className="text-2xl font-bold text-black mb-3">CheckBee</h3>
              <p className="text-gray-600 mb-4">3D checklists, inspections, and stakeholder collaboration</p>
              <ul className="space-y-2 text-sm text-gray-700 mb-6">
                <li>• Guided 3D inspections</li>
                <li>• AR real-size comparison</li>
                <li>• Stakeholder sync</li>
                <li>• Evidence submission</li>
              </ul>
              <a href="#signup" className="block w-full bg-gray-200 group-hover:bg-[#FFC33A] text-black text-center py-3 rounded-lg transition font-semibold">
                Know More
              </a>
            </div>

            {/* Hive */}
            <div className="bg-white group rounded-2xl p-8 shadow-lg border-2 border-gray-300 hover:border-[#FFC33A] transition">
             
              <Activity className="w-12 h-12 text-gray-400 group-hover:text-[#FFC33A] mb-4" />
              <h3 className="text-2xl font-bold text-black mb-3">Hive</h3>
              <p className="text-gray-600 mb-4">Real-time IoT digital twin for remote monitoring</p>
              <ul className="space-y-2 text-sm text-gray-700 mb-6">
                <li>• Live IoT data overlay</li>
                <li>• 3D digital twin</li>
                <li>• Remote monitoring</li>
                <li>• Real-time alerts</li>
              </ul>
              <a href="#signup" className="block w-full bg-gray-200 group-hover:bg-[#FFC33A] text-black text-center py-3 rounded-lg transition font-semibold">
                Know More
              </a>
            </div>
          </div>
        </div>
      </section>
  );
}
